import { useState, useContext, useEffect } from "react";
import AgentLayout from "../../../AdminPortal/Layouts/Layout";
import {
  Row,
  Col,
  Typography,
  Space,
  Form,
  Divider,
  Button,
  Input,
  Image,
  Modal,
  Select,
  message,
  Spin,
  Popconfirm,
  // Tooltip,
} from "antd";
import useSWR from "swr";
import axios from "axios";
import { DeleteOutlined } from "@ant-design/icons";
import { colors } from "../../../AdminPortal/utils/colors";
import { CartContext } from "../../../Contexts/CartContext";
import { useNavigate } from "react-router";
import { city } from "./City";
import { state } from "./State";
import rightArrow from "../../../../assets/icons/rightArrow.svg";
import downArrow from "../../../../assets/icons/downArrow.svg";
import UserContext from "../../../Contexts/UserContext";
import { isMobile } from "react-device-detect";
import { BASE_URL } from '../../../Constants/EnvironmentVariableProvider';
import { RoutesLookup } from '../../../Routes/RoutesLookup';
import {
  AGENT_REWARD_POST,
  GET_AGENT_BY_ID_API,
  GET_CART_ADDRESS_API,
  UPDATE_CART_ADDRESS_API,
  EDIT_AGENT_API
} from '../../../API/paths';
import PointsDisplay from "../../../AdminPortal/components/AgentPoints/AgentPoints";
import CartItemModal from "./cartItemModal";
import AddressConfirmationModal from "../../components/AddressConfirmationModal";
const { Text, Title } = Typography;

const AgentCart = () => {
  const { cart, addToCart, deleteItemCart, fetchCart, modifyQuantity } = useContext(CartContext);
  useEffect(() => {
    fetchCart()
    // eslint-disable-next-line
  },[])
  const { auth } = useContext(UserContext);
  const { data: agent, isValidating: addressloading, mutate: mutateAgent } = useSWR({
    url: BASE_URL + GET_AGENT_BY_ID_API + "?KeyId=" + auth?.result?.ACAG_KeyID,
  });
  const { data: cartAddress } = useSWR({
    url: BASE_URL + GET_CART_ADDRESS_API + "?agentKeyId=" + auth?.result?.ACAG_KeyID,
  });
  const navigate = useNavigate();
  // const [modalOpen, setModalopen] = useState(false);
  const [showDetailedProduct, setShowDetailedProduct] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [email_form] = Form.useForm();
  const [address_form] = Form.useForm();
  const [data, setData] = useState(cart);
  const [changeIconEmail, setChangeIconEmail] = useState(true);
  const [changeIconAddress, setChangeIconAddress] = useState(true);
  const [addressConfirmVisible, setAddressConfirmVisible] = useState(false);

  useEffect(() => {
    email_form.setFieldsValue({
      email: agent?.result?.ACAG_Email,
      phone: agent?.result?.ACAG_Phone,
    });
  }, [agent, email_form]);
  useEffect(() => {
    if (cartAddress?.result) {
      address_form.setFieldsValue({
        street_address: cartAddress.result.MSAD_Address_Line1,
        street_address2: cartAddress.result.MSAD_Address_Line2,
        city: cartAddress.result.MSAD_City,
        state: cartAddress.result.MSAD_State,
        zip: cartAddress.result.MSAD_ZipCode,
      });
    }
  // eslint-disable-next-line
  }, [cartAddress]);
  const handleAddressModalConfirm = () => {
    setAddressConfirmVisible(false);
    updateDefaultAddress();
  };
  
  const handleAddressModalCancel = () => {
    setAddressConfirmVisible(false);
    // Continue with redemption without updating default address
    const formData1 = email_form.getFieldsValue();
    const formData2 = address_form.getFieldsValue();
    proceedWithRedemption(formData1, formData2);
  };
  const handleAddressChange = async (event) => {
    const formValues = address_form.getFieldsValue();
    try {
      const payload = {
        ACAG_KeyID: auth?.result?.ACAG_KeyID,
        MSAD_City: formValues.city,
        MSAD_State: formValues.state,
        MSAD_ZipCode: formValues.zip,
        MSAD_Address_Line1: formValues.street_address,
        MSAD_Address_Line2: formValues.street_address2
      };
  
      await axios.put(BASE_URL + UPDATE_CART_ADDRESS_API, payload);
    } catch (error) {
      message.error("Failed to update shipping address");
    }
  };

  const ensureAgentPhone = async (phoneValue) => {
    const trimmedPhone = phoneValue?.toString().trim();

    if (!trimmedPhone) {
      message.warning("Please enter Phone Number");
      return false;
    }

    if (!agent?.result?.ACAG_KeyID || trimmedPhone === agent?.result?.ACAG_Phone) {
      return true;
    }

    try {
      const payload = {
        ACAG_KeyID: agent?.result?.ACAG_KeyID,
        ACAG_Email: agent?.result?.ACAG_Email,
        ACAG_Phone: trimmedPhone,
        ACAG_Agency_Name: agent?.result?.ACAG_Agency_Name,
        ACAG_Points_Earned: agent?.result?.ACAG_Points_Earned,
        ACAG_Points_Redeemed: agent?.result?.ACAG_Points_Redeemed,
        ACAG_Image_String: agent?.result?.ACAG_Image_Path,
        ACAG_Is_Active: agent?.result?.ACAG_Is_Active,
        tbl_MSAD_Addresses: agent?.result?.tbl_MSAD_Addresses == null
          ? null
          : {
              MSAD_City: agent?.result?.tbl_MSAD_Addresses?.MSAD_City,
              MSAD_State: agent?.result?.tbl_MSAD_Addresses?.MSAD_State,
              MSAD_ZipCode: agent?.result?.tbl_MSAD_Addresses?.MSAD_ZipCode,
              MSAD_Address_Line1: agent?.result?.tbl_MSAD_Addresses?.MSAD_Address_Line1,
              MSAD_Address_Line2: agent?.result?.tbl_MSAD_Addresses?.MSAD_Address_Line2,
            },
      };

      await axios.put(EDIT_AGENT_API, payload);
      mutateAgent?.();
      return true;
    } catch (error) {
      console.error(error);
      message.error("Failed to update phone number. Please try again.");
      return false;
    }
  };
  
  const detailBtnEmailHandler = () => {
    setChangeIconEmail(!changeIconEmail);
  };
  const detailBtnAddrressHandler = () => {
    setChangeIconAddress(!changeIconAddress);
  };
  
  const totalRedeemPoints = () => {
    let total = 0;
    data?.forEach((item) => {
      total = total + item.ARLR_Norm_Points * item.qty;
    });
    return total;
  };
  const deleteItem = (index) => {
    deleteItemCart(index);
    let dataCopy = [...data];
    dataCopy.splice(index, 1);
    setData(dataCopy);
  };
  const handleQuantity = async (
    index,
    type,
    reward_quantity,
    Redeemable_Quantity,
    itemId
  ) => {
    let dataCopy = [...data];
    let Quantity = 0;
    let filterData = data?.filter(
      (singleReward) => singleReward?.ARLR_KeyID === itemId
    );
    
    if (filterData?.length > 1) {
      filterData?.forEach((item) => {
        Quantity = item?.qty + Quantity;
      });
      if (
        (Quantity + 1 > Redeemable_Quantity && Redeemable_Quantity) ||
        Quantity + 1 > reward_quantity
      ) {
        message.error("Maximum order quantity exceeded.");
        return;
      }
    }
  
    const newQuantity = type === "+" 
      ? dataCopy[index].qty + 1 
      : dataCopy[index].qty - 1;

    if (newQuantity < 1) {
      return;
    }
    if (
      reward_quantity < newQuantity ||
      (Redeemable_Quantity && Redeemable_Quantity < newQuantity)
    ) {
      message.error("Maximum order quantity exceeded.");
      return;
    }
  
    const oldQuantity = dataCopy[index].qty;

    dataCopy[index].qty = newQuantity;
    setData(dataCopy);
  

    await modifyQuantity(
      dataCopy[index], 
      newQuantity,
      () => {

        dataCopy[index].qty = oldQuantity;
        setData([...dataCopy]);
      }
    );
  };
  
  const handleModal = (index) => {
    setShowDetailedProduct(index);
  };
  
  async function handleFormSubmit() {
    if (cart?.length < 1) {
      message.warning("Your Cart is Empty.");
      return;
    }
    if (JSON.parse(localStorage.getItem("totalPoints")) < totalRedeemPoints()) {
      message.warning("You have insufficient points for this transaction");
      return;
    }
    
    const formData1 = email_form.getFieldsValue();
    const formData2 = address_form.getFieldsValue();
    
    if (!formData1?.email) {
      message.warning("Please Enter Email Address");
      return;
    }

    if (!formData1?.phone) {
      message.warning("Please enter Phone Number");
      return;
    }

    const phoneSynced = await ensureAgentPhone(formData1?.phone);
    if (!phoneSynced) {
      return;
    }

    if (
      !formData2?.city ||
      !formData2?.state ||
      !formData2?.street_address ||
      //!formData2?.street_address2 ||
      !formData2?.zip
    ) {
      message.warning("Please Enter Shipping Address");
      return;
    }
    
    // Compare cart address with default address
    const isAddressDifferent = 
      formData2.street_address !== agent?.result?.tbl_MSAD_Addresses?.MSAD_Address_Line1 ||
      formData2.street_address2 !== agent?.result?.tbl_MSAD_Addresses?.MSAD_Address_Line2 ||
      formData2.city !== agent?.result?.tbl_MSAD_Addresses?.MSAD_City ||
      formData2.state !== agent?.result?.tbl_MSAD_Addresses?.MSAD_State ||
      formData2.zip !== agent?.result?.tbl_MSAD_Addresses?.MSAD_ZipCode;
    
    if (isAddressDifferent) {
      // Show confirmation modal
      setAddressConfirmVisible(true);
      return;
    }
    
    // If addresses are the same, proceed with the redemption
    proceedWithRedemption(formData1, formData2);
  }

  // Function to proceed with redemption after address check
  const proceedWithRedemption = async (formData1, formData2) => {
    const combinedFormData = { ...formData1, ...formData2 };
    const activeVariant = (variant_array) => {
      const selected_variant = variant_array?.filter((item) => item?.status);
      if (!selected_variant) {
        return 0;
      }
      return selected_variant[0]?.ARRV_Reward_Variant_KeyID;
    };
    
    let reward_data = [];
    cart?.forEach((item) => {
      const data = {
        ARIT_Reward_ARLR_keyId: item?.ARLR_KeyID,
        ARIT_Reward_Variant_ARRV_KeyID: activeVariant(
          item?.tbl_ARRV_Reward_Variants
        ),
        ARIT_Norm_Points: item?.ARLR_Norm_Points,
        ARIT_Accumulative_Points: item?.ARLR_Norm_Points * item?.qty,
        ARIT_Quantity: item?.qty,
      };
      reward_data.push(data);
    });
    
    const values = {
      ARAG_Agent_AGAC_keyId: auth?.result?.ACAG_KeyID,
      ARAG_Accumulative_Points: totalRedeemPoints(),
      ARAG_Shipping_Email: combinedFormData?.email,
      tbl_ARIT_Agent_Rewards_Items: reward_data,
    };

    setLoading(true);
    try {
      const response = await axios.post(AGENT_REWARD_POST, values);
      setLoading(false);
      if (response?.data?.success) {
        message.success(
          "Our reward request has been successfully created and is being reviewed by our team"
        );
        addToCart(-1);
        navigate(RoutesLookup.AGENT_DASHBOARD);
      } else {
        message.error(response?.data?.message);
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
    }
  };

  // Function to update default address
  const updateDefaultAddress = async () => {
    const formValues = address_form.getFieldsValue();
    setLoading(true);
    
    try {
      // Update the agent's default address
      const updateData = {
        ACAG_KeyID: auth?.result?.ACAG_KeyID,
        ACAG_Email: agent?.result?.ACAG_Email,
        ACAG_Phone: email_form.getFieldValue("phone") || agent?.result?.ACAG_Phone,
        ACAG_Agency_Name: agent?.result?.ACAG_Agency_Name,
        ACAG_Points_Earned: agent?.result?.ACAG_Points_Earned,
        ACAG_Points_Redeemed: agent?.result?.ACAG_Points_Redeemed,
        ACAG_Image_String: agent?.result?.ACAG_Image_Path,
        ACAG_Is_Active: agent?.result?.ACAG_Is_Active,
        tbl_MSAD_Addresses: {
          MSAD_City: formValues.city,
          MSAD_State: formValues.state,
          MSAD_ZipCode: formValues.zip,
          MSAD_Address_Line1: formValues.street_address,
          MSAD_Address_Line2: formValues.street_address2 || "",
        },
      };
      
      await axios.put(EDIT_AGENT_API, updateData);
      message.success("Default address updated successfully!");
    } catch (error) {
      console.error(error);
      message.error("Failed to update default address, but continuing with your order.");
    } finally {
      // Continue with redemption regardless of whether address update succeeded or failed
      const formData1 = email_form.getFieldsValue();
      const formData2 = address_form.getFieldsValue();
      proceedWithRedemption(formData1, formData2);
    }
  };

  return (
    <Spin
      spinning={loading}
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <AgentLayout>
        <div
          style={{
            paddingLeft: isMobile ? 14 : 60,
            paddingRight: isMobile ? 14 : 60,
            marginTop: 28,
            marginBottom: 20,
          }}
        >
          <div style={{ marginBottom: 10 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Title level={5} style={{ color: colors.black }}>
                Here is your Cart
              </Title>
              <PointsDisplay points={JSON.parse(localStorage.getItem("totalPoints"))} />
            </div>
          </div>
          {isMobile ? (
            <div>
              <div style={{ width: "100%" }}>
                {data?.length > 0 ? (
                  <div style={{ marginBottom: 16 }}>
                    <tr>
                      <th style={{ float: "left" }}>Rewards</th>
                    </tr>
                  </div>
                ) : (
                  <p>Cart is empty </p>
                )}
                <div>
                  {data?.map((item, index) => {
                    return (
                      <div
                        key={"agent-cart-details" + index}
                        style={{
                          marginTop: index !== 0 && 20,
                          boxShadow:
                            "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
                          borderRadius: 7,
                          paddingLeft: 16,
                          paddingBottom: 16,
                          paddingTop: 16,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            cursor: "pointer",
                            justifyContent: "space-between",
                          }}
                        >
                          <div
                            onClick={() => {
                              handleModal(index);
                            }}
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <div
                              style={{
                                width: 57,
                              }}
                            >
                              <Image
                                style={{
                                  border: "1px solid" + colors.grayNeutral300,
                                  borderRadius: 7,
                                }}
                                preview={false}
                                width={57}
                                height={57}
                                src={item?.ARLR_Image_Path}
                                alt="icon"
                              />
                            </div>
                            <div style={{ marginLeft: 8 }}>
                              <Space direction="vertical" size={0}>
                                <Text
                                  style={{
                                    color: colors.black,
                                    fontWeight: 500,
                                  }}
                                >
                                  {item?.ARLR_Title}
                                </Text>
                                <Text>{item?.ARLR_Description}</Text>
                              </Space>
                            </div>
                          </div>
                          <Popconfirm
                            title="Are you sure you want to  delete this item from cart?"
                            okText="Yes"
                            cancelText="No"
                            onConfirm={() => deleteItem(index)}
                          >
                            <Button type="text">
                              <DeleteOutlined style={{ color: colors.red }} />
                            </Button>
                          </Popconfirm>
                        </div>

                        <div
                          style={{
                            marginTop: 16,
                            paddingRight: 16,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div>
                            <p>Quantity</p>
                            <div
                              style={{
                                marginTop: 10,
                                textAlign: "center",
                                color: colors.black,
                              }}
                            >
                              <Button
                                onClick={() => handleQuantity(index, "-")}
                              >
                                -
                              </Button>

                              <span style={{ padding: 5 }}>{item?.qty}</span>

                              <Button
                                onClick={() =>
                                  handleQuantity(
                                    index,
                                    "+",
                                    item?.ARLR_Quantity,
                                    item?.ARLR_Redeemable_Quantity,
                                    item?.ARLR_KeyID
                                  )
                                }
                              >
                                +
                              </Button>
                            </div>
                          </div>
                          <div>
                            <p>Radeem Points</p>
                            <div
                              style={{
                                textAlign: "center",
                                color: colors.black,
                              }}
                            >
                              <Text>{item?.ARLR_Norm_Points}</Text>
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            marginTop: 16,
                            paddingRight: 16,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div>
                            <p>Variant</p>
                            <div style={{ textAlign: "center" }}>
                              {data[index]?.tbl_ARRV_Reward_Variants?.map(
                                (item) => (
                                  <div key={item?.ARRV_Reward_Variant_KeyID}>
                                    {item?.status && (
                                      <Text>{item?.ARRV_Title}</Text>
                                    )}
                                  </div>
                                )
                              )}
                            </div>
                          </div>
                          <div>
                            <p>Total Radeem Points</p>
                            <div
                              style={{
                                textAlign: "center",
                                color: colors.black,
                              }}
                            >
                              <Text>{item?.ARLR_Norm_Points * item?.qty}</Text>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
              <Col span={24}>
                <div style={{ backgroundColor: colors.bgGrey, marginTop: 25 }}>
                  <Spin spinning={addressloading}>
                    <div style={{ padding: 10 }}>
                      <Title level={4} style={{ color: colors.black }}>
                        Order Summary
                      </Title>
                      <Divider />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: 8,
                        }}
                      >
                        <Text style={{ fontWeight: 600 }}>Total Products:</Text>
                        <Text style={{ fontWeight: 600 }}>{data?.length}</Text>
                      </div>
                      <div>
                        <div>
                          <Button
                            style={{
                              fontWeight: 600,
                              padding: 0,
                              paddingRight: 5,
                            }}
                            onClick={detailBtnEmailHandler}
                            type="link"
                          >
                            Add Email Address
                          </Button>

                          <Image
                            style={{ marginBottom: 3 }}
                            preview={false}
                            src={changeIconEmail ? downArrow : rightArrow}
                            alt="icon"
                          />
                        </div>
                        {changeIconEmail && (
                          <Form
                            form={email_form}
                            layout="vertical"
                            autoComplete="off"
                          >
                            <Form.Item
                              name="email"
                              label={
                                <label style={{ color: "#737373" }}>
                                  Email
                                </label>
                              }
                              style={{ marginTop: "8px" }}
                              rules={[
                                {
                                  required: true,
                                  type: "email",
                                },
                              ]}
                            >
                              <Input style={{ width: "100%" }} />
                            </Form.Item>
                            <Form.Item
                              name="phone"
                              label={
                                <label style={{ color: "#737373" }}>
                                  Phone
                                </label>
                              }
                              style={{ marginTop: "8px" }}
                              rules={[
                                {
                                  required: true,
                                  message: "Phone number is required",
                                },
                              ]}
                            >
                              <Input 
                                placeholder="(555) 123-4567"
                                maxLength={20}
                                style={{ width: "100%" }} 
                              />
                            </Form.Item>
                          </Form>
                        )}

                        <Space direction="horizontal" size={6}>
                          <Button
                            style={{
                              fontWeight: 600,
                              padding: 0,
                              paddingRight: 5,
                            }}
                            onClick={detailBtnAddrressHandler}
                            type="link"
                          >
                            Add Shipping Address
                          </Button>

                          <Image
                            style={{ marginBottom: 3 }}
                            preview={false}
                            src={changeIconAddress ? downArrow : rightArrow}
                            alt="icon"
                          />
                        </Space>
                        {changeIconAddress && (
                          <Form
                            form={address_form}
                            layout="vertical"
                            autoComplete="off"
                            onBlur={handleAddressChange}
                          >
                            <Form.Item
                              name="street_address"
                              label={
                                <label style={{ color: "#404040" }}>
                                  Street Address 1
                                </label>
                              }
                              style={{ marginTop: "8px" }}
                              rules={[
                                {
                                  message: "Street Address 1 is required",
                                  required: true,
                                  type: "string",
                                },
                              ]}
                            >
                              <Input style={{ width: "100%" }} />
                            </Form.Item>

                            <Form.Item
                              name="street_address2"
                              label={
                                <label style={{ color: "#404040" }}>
                                  Street Address 2
                                </label>
                              }
                              style={{ marginTop: -16 }}
                            >
                              <Input style={{ width: "100%" }} />
                            </Form.Item>

                            <Row gutter={14} style={{ marginTop: -20 }}>
                              <Col span={12}>
                                <Form.Item
                                  name="city"
                                  label={
                                    <label style={{ color: "#404040" }}>
                                      City
                                    </label>
                                  }
                                  style={{ marginTop: "8px" }}
                                >
                                  <Select
                                    showSearch
                                    placeholder="Select a City"
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      (option?.label ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    options={city}
                                  />
                                </Form.Item>
                              </Col>
                              <Col span={12}>
                                <Form.Item
                                  name="state"
                                  label={
                                    <label style={{ color: "#404040" }}>
                                      State
                                    </label>
                                  }
                                  style={{ marginTop: "8px" }}
                                >
                                  <Select
                                    showSearch
                                    placeholder="Select a State"
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      (option?.label ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    options={state}
                                  />
                                </Form.Item>
                              </Col>
                            </Row>

                            <Form.Item
                              name="zip"
                              label={
                                <label style={{ color: "#404040" }}>Zip</label>
                              }
                              style={{ marginTop: -14 }}
                            >
                              <Input style={{ width: "100%" }} />
                            </Form.Item>
                          </Form>
                        )}
                      </div>
                      <Divider />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: 8,
                        }}
                      >
                        <Text style={{ fontWeight: 600 }}>
                          Total Reward Points
                        </Text>
                        <Text style={{ color: colors.black, fontWeight: 600 }}>
                          {totalRedeemPoints()}
                        </Text>
                      </div>
                      <Button
                        style={{ width: "100%", marginBottom: 20 }}
                        type="primary"
                        onClick={handleFormSubmit}
                      >
                        Redeem Now!
                      </Button>
                    </div>
                  </Spin>
                </div>
              </Col>
            </div>
          ) : (
            <Row
              gutter={{
                xs: 8,
                sm: 16,
                md: 24,
                lg: 32,
              }}
            >
              <Col className="gutter-row" span={18}>
                <div style={{ height: "80vh", overflow: "auto" }}>
                  <table style={{ width: "99%" }}>
                    <thead>
                      <tr>
                        <th style={{ float: "left" }}>Rewards</th>
                        <th></th>
                        <th>Variant</th>
                        <th>Quantity</th>
                        <th>Redeem Points</th>
                        <th>Total Redeem Points</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.map((item, index) => {
                        return (
                          <tr
                            key={"agent-cart-redeempoints" + index}
                            style={{
                              boxShadow:
                                "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
                              borderRadius: 7,
                            }}
                          >
                            <td style={{ padding: 5, width: "10%" }}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  cursor: "pointer",
                                  padding: "0px 20px",
                                }}
                                onClick={() => {
                                  handleModal(index);
                                }}
                              >
                                <Image
                                  style={{
                                    border: "1px solid" + colors.grayNeutral300,
                                    borderRadius: 7,
                                    objectFit: "contain",
                                  }}
                                  preview={false}
                                  width={57}
                                  height={57}
                                  src={item?.ARLR_Image_Path}
                                  alt="icon"
                                />
                              </div>
                            </td>
                            <td style={{ width: "30%" }}>
                              <pre
                                style={{
                                  backgroundColor: "transparent",
                                  border: "none",
                                  fontFamily: "inherit",
                                  whiteSpace: "pre-wrap",
                                  padding: "20px 0px",
                                }}
                              >
                                {item?.ARLR_Title}
                              </pre>
                            </td>
                            <td style={{ textAlign: "center", width: "20%" }}>
                              {data[index]?.tbl_ARRV_Reward_Variants?.map(
                                (item) => (
                                  <div key={item?.ARRV_Reward_Variant_KeyID}>
                                    {item?.status && (
                                      <Text>{item?.ARRV_Title}</Text>
                                    )}
                                  </div>
                                )
                              )}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                color: colors.black,
                                width: "15%",
                              }}
                            >
                              <Button
                                onClick={() => handleQuantity(index, "-")}
                              >
                                -
                              </Button>
                              <span style={{ padding: 5 }}>{item?.qty}</span>
                              <Button
                                onClick={() =>
                                  handleQuantity(
                                    index,
                                    "+",
                                    item?.ARLR_Quantity,
                                    item?.ARLR_Redeemable_Quantity,
                                    item?.ARLR_KeyID
                                  )
                                }
                              >
                                +
                              </Button>
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                color: colors.black,
                                width: "5%",
                              }}
                            >
                              <Text>{item?.ARLR_Norm_Points}</Text>
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                color: colors.black,
                                width: "10%",
                              }}
                            >
                              <Text>{item?.ARLR_Norm_Points * item?.qty}</Text>
                            </td>
                            <td style={{ textAlign: "left", width: "10%" }}>
                              <Popconfirm
                                title="Are you sure you want to  delete this item from cart?"
                                okText="Yes"
                                cancelText="No"
                                onConfirm={() => deleteItem(index)}
                              >
                                <Button type="text">
                                  <DeleteOutlined
                                    style={{ color: colors.red }}
                                  />
                                </Button>
                              </Popconfirm>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </Col>
              <Col className="gutter-row" span={6}>
                <div
                  style={{
                    backgroundColor: colors.bgGrey,
                    marginTop: 25,
                    height: "80vh",
                    overflow: "auto",
                  }}
                >
                  <Spin spinning={addressloading}>
                    <div style={{ padding: 10 }}>
                      <Title level={4} style={{ color: colors.black }}>
                        Order Summary
                      </Title>
                      <Divider />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: 8,
                        }}
                      >
                        <Text style={{ fontWeight: 600 }}>Total Products:</Text>
                        <Text style={{ fontWeight: 600 }}>{data?.length}</Text>
                      </div>
                      <div>
                        <div>
                          <Button
                            style={{
                              fontWeight: 600,
                              padding: 0,
                              paddingRight: 5,
                            }}
                            onClick={detailBtnEmailHandler}
                            type="link"
                          >
                            Add Email Address
                          </Button>

                          <Image
                            style={{ marginBottom: 3 }}
                            preview={false}
                            src={changeIconEmail ? downArrow : rightArrow}
                            alt="icon"
                          />
                        </div>
                        {changeIconEmail && (
                          <Form
                            form={email_form}
                            layout="vertical"
                            autoComplete="off"
                          >
                            <Form.Item
                              name="email"
                              label={
                                <label style={{ color: "#737373" }}>
                                  Email
                                </label>
                              }
                              style={{ marginTop: "8px" }}
                              rules={[
                                {
                                  required: true,
                                  type: "email",
                                },
                              ]}
                            >
                              <Input style={{ width: "100%" }} />
                            </Form.Item>
                            <Form.Item
                              name="phone"
                              label={
                                <label style={{ color: "#737373" }}>
                                  Phone
                                </label>
                              }
                              style={{ marginTop: "8px" }}
                              rules={[
                                {
                                  required: true,
                                  message: "Phone number is required",
                                },
                              ]}
                            >
                              <Input 
                                placeholder="(555) 123-4567"
                                maxLength={20}
                                style={{ width: "100%" }} 
                              />
                            </Form.Item>
                          </Form>
                        )}

                        <Space direction="horizontal" size={6}>
                          <Button
                            style={{
                              fontWeight: 600,
                              padding: 0,
                              paddingRight: 5,
                            }}
                            onClick={detailBtnAddrressHandler}
                            type="link"
                          >
                            Add Shipping Address
                          </Button>

                          <Image
                            style={{ marginBottom: 3 }}
                            preview={false}
                            src={changeIconAddress ? downArrow : rightArrow}
                            alt="icon"
                          />
                        </Space>
                        {changeIconAddress && (
                          <Form
                            form={address_form}
                            layout="vertical"
                            autoComplete="off"
                            onBlur={handleAddressChange}
                          >
                            <Form.Item
                              name="street_address"
                              label={
                                <label style={{ color: "#404040" }}>
                                  Street Address 1
                                </label>
                              }
                              style={{ marginTop: "8px" }}
                              rules={[
                                {
                                  required: true,
                                  type: "string",
                                },
                              ]}
                            >
                              <Input style={{ width: "100%" }} />
                            </Form.Item>

                            <Form.Item
                              name="street_address2"
                              label={
                                <label style={{ color: "#404040" }}>
                                  Street Address 2
                                </label>
                              }
                              style={{ marginTop: -16 }}
                            >
                              <Input style={{ width: "100%" }} />
                            </Form.Item>

                            <Row gutter={14} style={{ marginTop: -20 }}>
                              <Col span={12}>
                                <Form.Item
                                  name="city"
                                  label={
                                    <label style={{ color: "#404040" }}>
                                      City
                                    </label>
                                  }
                                  style={{ marginTop: "8px" }}
                                >
                                  <Input style={{ width: "100%" }} />
                                  {/*   <Select
                                    placeholder="S"
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      (option?.label ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    options={city}
                                  /> */}
                                </Form.Item>
                              </Col>
                              <Col span={12}>
                                <Form.Item
                                  name="state"
                                  label={
                                    <label style={{ color: "#404040" }}>
                                      State
                                    </label>
                                  }
                                  style={{ marginTop: "8px" }}
                                >
                                  <Select
                                    showSearch
                                    placeholder="Select a State"
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      (option?.label ?? "")
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    options={state}
                                  />
                                </Form.Item>
                              </Col>
                            </Row>

                            <Form.Item
                              name="zip"
                              label={
                                <label style={{ color: "#404040" }}>Zip</label>
                              }
                              style={{ marginTop: -14 }}
                            >
                              <Input style={{ width: "100%" }} />
                            </Form.Item>
                          </Form>
                        )}
                      </div>
                      <Divider />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          marginBottom: 8,
                        }}
                      >
                        <Text style={{ fontWeight: 600 }}>
                          Total Reward Points
                        </Text>
                        <Text style={{ color: colors.black, fontWeight: 600 }}>
                          {totalRedeemPoints()}
                        </Text>
                      </div>
                      <Button
                        style={{ width: "100%", marginBottom: 20 }}
                        type="primary"
                        onClick={handleFormSubmit}
                      >
                        Redeem Now!
                      </Button>
                    </div>
                  </Spin>
                </div>
              </Col>
            </Row>
          )}
        </div>
        <Modal
          open={showDetailedProduct !== undefined}
          footer={null}
          width="80%"
          onCancel={() => handleModal(undefined)}
        >
          <CartItemModal
            cart={cart}
            currentIndex={showDetailedProduct}
            onClose={() => handleModal(undefined)}
            onNavigate={setShowDetailedProduct}
          />
        </Modal>
        <AddressConfirmationModal
  visible={addressConfirmVisible}
  onUpdateAddress={handleAddressModalConfirm}
  onContinueWithoutUpdate={handleAddressModalCancel}
  onCancel={() => setAddressConfirmVisible(false)}
  currentAddress={agent?.result?.tbl_MSAD_Addresses ? {
    street_address: agent.result.tbl_MSAD_Addresses.MSAD_Address_Line1,
    street_address2: agent.result.tbl_MSAD_Addresses.MSAD_Address_Line2,
    city: agent.result.tbl_MSAD_Addresses.MSAD_City,
    state: agent.result.tbl_MSAD_Addresses.MSAD_State,
    zip: agent.result.tbl_MSAD_Addresses.MSAD_ZipCode
  } : null}
  newAddress={address_form.getFieldsValue()}
/>
      </AgentLayout>
    </Spin>
  );
};
export default AgentCart;